<template lang="pug">
  div
    order-step(:current-step="5")
    h2 Auftrag bestätigen
    table(v-if="orderSummary")
      tbody
        tr
          td.header-col.px-4 Datum
          td {{ today | dateFormatter }}
          td.header-col.px-5.hide-on-small Rechnung
        tr
          td(colspan="2")
          td.px-5.align-top.hide-on-small(rowspan="4")
            div(v-if="customer.name1") {{ customer.name1 }}
            div(v-if="customer.name2") {{ customer.name2 }}
            div(v-if="customer.street") {{ customer.street }}
            div {{ customer.country }}-{{ customer.zip }} {{ customer.city }}
        tr
          td.header-col.px-4 Preis
          td(v-if="customer && customer.studentProducts === 1") {{ orderSummary.totalPriceB2c }}
          td(v-else) {{ orderSummary.totalPriceB2b }}
        tr
          td.header-col.px-4 Menge
          td {{ orderSummary.totalQuantity }}
        tr
          td.header-col.px-4 {{ discountLabel }}
          td {{ orderSummary.onlineDiscount }}
          td.hide-on-small
        tr
          td.header-col.px-4 Versandkostenpauschale
          td {{ orderSummary.shippingCosts }}
          td.header-col.px-5.hide-on-small Versand
        tr
          td(colspan="2")
          td.px-5.align-top.hide-on-small(rowspan="3")
            div(v-if="deliveryAddress.name1") {{ deliveryAddress.name1 }}
            div(v-if="deliveryAddress.name2") {{ deliveryAddress.name2 }}
            div(v-if="deliveryAddress.street") {{ deliveryAddress.street }}
            div {{ deliveryAddress.country }}-{{ deliveryAddress.zip }} {{ deliveryAddress.city }}
        tr
          td.header-col.px-4 {{ orderSummary.vatPercentage }}
          td {{ orderSummary.vat }}
        tr
          td.header-col.px-4 Gesamt
          td {{ orderSummary.totalPrice }}
        tr
          td.header-col.px-4 Kommentar
          td(colspan="2") {{ orderNotes }}
    div.px-4.py-4.show-on-small
      strong Rechnung:
      div(v-if="customer.name1") {{ customer.name1 }}
      div(v-if="customer.name2") {{ customer.name2 }}
      div(v-if="customer.street") {{ customer.street }}
      div {{ customer.country }}-{{ customer.zip }} {{ customer.city }}
      br
      strong Versand:
      div(v-if="deliveryAddress.name1") {{ deliveryAddress.name1 }}
      div(v-if="deliveryAddress.name2") {{ deliveryAddress.name2 }}
      div(v-if="deliveryAddress.street") {{ deliveryAddress.street }}
      div {{ deliveryAddress.country }}-{{ deliveryAddress.zip }} {{ deliveryAddress.city }}
      br

    div.px-4.py-4
      strong Firmensitz:
      br
      | MALU WILZ Beauté GmbH
      br
      | Gaußstraße 13
      br
      | 85757 Karlsfeld
      br
      | Deutschland
    form.my-3(@submit.prevent
      :class="['pl-4 alert', { 'alert-danger': !agreed && hoveringAgreeBtn }]"
      )
      div.form-group.form-check.fat-checkbox.py-4.mb-0
        input.form-check-input(
          type="checkbox"
          id="agree"
          v-model="agreed"
          :disabled="ordering"
          )
        label.form-check-label.pl-2.agree-label(for="agree")
          | Ich habe die&nbsp;
          a(:href="url.agb" target="_blank" rel="noopener")
            | AGB&nbsp;
          | und&nbsp;
          a(:href="url.datenschutz" target="_blank" rel="noopener")
            | Datenschutzbestimmungen&nbsp;
          | gelesen und stimme diesen zu.
    div.card-footer.text-right(v-if="orderSummary")
      button.mr-2.btn.btn-secondary(
        type="button"
        @click="goBack"
        :disabled="ordering"
        )
        | Zurück
      button.btn.btn-primary.btn-lg(
        type="button"
        @click="placeOrder"
        :disabled="ordering || !agreed"
        )
        span(
          @mouseover="hoveringAgreeBtn = true"
          @mouseleave="hoveringAgreeBtn = false"
        )
          | Zahlungspflichtig Bestellen
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import OrderStep from '@/components/orderForm/orderStep'
import OrderNotes from '@/components/orderForm/orderNotes'
import filters from '@/mixins/filters'
import { cmsPage } from '@/cmsPages'

export default {
  name: 'DeliveryAddress',
  components: {
    OrderNotes,
    OrderStep
  },
  mixins: [filters],
  data: () => ({
    agreed: false,
    hoveringAgreeBtn: false
  }),
  computed: {
    ...mapState('orderForm', [
      'orderNotes',
      'deliveryAddress'
    ]),
    ...mapState({
      ordering: state => !!state.orderFormService.loadingIndicators.createOrder
    }),
    ...mapGetters('authentication', [
      'customer'
    ]),
    ...mapState('orderForm', [
      'orderSummary'
    ]),
    discountLabel () {
      return this.customer && this.customer.studentProducts === 1
        ? 'Schüler-Rabatt 10%'
        : 'Online-Rabatt 3%'
    },
    today () {
      return (new Date()).toISOString()
    },
    url () {
      return {
        agb: cmsPage('agb'),
        datenschutz: cmsPage('datenschutz')
      }
    }
  },
  methods: {
    ...mapActions('ui', [
      'goBack'
    ]),
    ...mapActions('orderForm', [
      'placeOrder'
    ])
  }
}
</script>

<style lang="stylus" scoped>
  .spinner
    width 64px
    height 64px
    position absolute
    top 200px
    left calc(50% - 32px)

    &.spinner-border
      border 0.25em solid currentColor
      border-right-color transparent

  td.header-col
    font-weight bold

  .btn-primary.disabled, .btn-primary:disabled
    cursor not-allowed

  .agree-label

    a
      display inline-block
      text-decoration underline

  .show-on-small
    display none

  @media (max-width 640px)
    .show-on-small
      display block

    .hide-on-small
      display none

</style>
